export const SET_MOBILE_SETTING = 'SET_MOBILE_SETTING';

export enum BoardPageAppearance {
    'canvas' = 'canvas',
    'list' = 'list',
}

export type SetMobileSettingAction = {
    type: typeof SET_MOBILE_SETTING;
    setting: string;
    value: any;
};
